<template>
  <div class="main-container " :class="isDesktop ? '' : 'mobile'" ref="matchAnalysis">
    <div class="child-container is-row columns column is-12-desktop is-12-tablet is-12-mobile is-centered">
      <div class="columns is-centered is-bordered-box-shadow-main">
        <div class="next-games-container">
          <div class="next-matches-title is-hidden-tablet">
            {{ sectionName }}
          </div>
          <DesktopMenuNextMatches v-if="isDesktop" 
            :size="size" 
            @changeLive="onChangeLive" 
            @advancedFilter="onClickAdvancedFilter" 
            @changeAnalysisType="onChangeAnalytsis"
          />
          <MobileMenuNextMatches v-else 
            :size="size" 
            @changeLive="onChangeLive" 
            @advancedFilter="onClickAdvancedFilter" 
            @changeAnalysisType="onChangeAnalytsis"
          />
          <AdvanceFilter 
            @close="onCloseFilter"
            @apply="onApplyFilter"
          />
          <div class="columns general">
            <div class="column menu-left" v-if="isDesktop">
              <div class="flex-container">
                <template v-for="(item, index) in viewOptions">
                  <ItemNextMatches
                    :item="item"
                    :key="index"
                    :id="idAssetSelected"
                    class="flex-item column is-6"
                    :class="{ disabled: item.id === 6 || item.id === 8 }"
                    style="display:inline-block"
                    :size="size"
                  >
                  </ItemNextMatches>
                </template>
              </div>
            </div>
            <div class="column is-10">
              <ViewContainer :size="size">
                <template v-slot:content>
                  <Component 
                    :is="currentComponent"
                    @distribucionLiveVsita="onChangeDistribucionLiveVista"
                    @tendenciaLiveChangeTeam="onChangeTeamTendenciaLive"
                    @tendenciaLiveChangeVista="onChangeTendenciaLiveVista"
                    @tendenciaLiveChangeSubcategory="onChangeTendenciaLiveSubcategory"
                  ></Component>
                </template>
              </ViewContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemNextMatches from '@/components/Elements/NextMatches/ItemNextMatches';
import ViewContainer from '@/components/Sections/NextMatches/Container';
import Resumen from '@/components/Sections/NextMatches/Resumen';
import Barras from '@/components/Sections/NextMatches/Barras';
import Distribucion from '@/components/Sections/NextMatches/Distribucion';
import Fuerza from '@/components/Sections/NextMatches/Fuerza';
import Tabla from '@/components/Sections/NextMatches/Tabla';
import Cancha from '@/components/Sections/NextMatches/Cancha';
import TendenciaLive from '@/components/Sections/NextMatches/TendenciaLive';
import GolstatsLive from '@/components/Sections/NextMatches/GolstatsLive';
import DesktopMenuNextMatches from '@/components/NavBars/DesktopMenuNextMatches';
import MobileMenuNextMatches from '@/components/NavBars/MobileMenuNextMatches';
import AdvanceFilter from '@/components/Elements/NextMatches/AdvanceFilter.vue';
import options from '@/data/next/options';
import { mapGetters, mapMutations } from 'vuex';
import { analisisPartidoSeccion, analisisPartidosAplicarFiltros, analisisPartidosCerrarFiltroAvanzando, analisisPartidoLive, analisisPartidoFiltrosAvanzados, analisisPartidoFiltroTipoDeAnalisis, analisisPartidoDistribucionLiveVista, analisisPartidoTendenciaLiveEquipo, analisisPartidoTendenciaLiveVista, analisisPartidoTendenciaLiveCategoria } from '@/utils/analytics/nextMatches';

export default {
  name: 'MatchAnalysis',
  components: {
    ItemNextMatches,
    DesktopMenuNextMatches,
    MobileMenuNextMatches,
    AdvanceFilter,
    ViewContainer,
    Resumen,
    Barras,
    Distribucion,
    Fuerza,
    Tabla,
    Cancha,
    TendenciaLive,
    GolstatsLive,
  },
  data() {
    return {
      viewOptions: null,
      size: 769,
    };
  },
  created() {
    window.addEventListener('resize', () => this.setSize());
    try {
      this.viewOptions = options.viewOptions;
      this.$store.dispatch('nextGeneral/checkState', {
        gameId: this.$route.params.gameId,
        isTeamsAnalysis: true,
      });
      // eslint-disable-next-line no-empty
    } catch {}
  },
  mounted() {
    this.setSize();
    window.scrollTo(0, 0)
  },
  beforeDestroy() {
    this.$store.dispatch('nextGeneral/exitChannel');
    this.$store.dispatch('nextGeneral/cleanAllStats');
  },
  watch: {
    '$socket.connected': {
      immediate: true,
      handler(newValue) {
        this.updateIsSocketConnected(newValue);
      },
    },
    idAssetSelected() {
      let name = this.currentComponent.replace(' ', '_').toLowerCase();
      analisisPartidoSeccion(name, this.seasonId, this.gameId);
    }
  },
  computed: {
    ...mapGetters('nextGeneral', ['idAssetSelected', 'gameId']),
    ...mapGetters('filterGeneral',{ seasonId: 'getSeasonId' }),
    isDesktop() {
      return this.size > 768;
    },
    currentComponent() {
      return this.viewOptions
        ? this.viewOptions.find(option => option.id === this.idAssetSelected).component
        : 'Resumen';
    },
    sectionName() {
      let currentName = '';
      switch (this.currentComponent) {
        case 'Resumen':
          currentName = 'Resumen';
          break;
        case 'Barras':
          currentName = 'Barras';
          break;
        case 'Distribucion':
          currentName = 'Distribución';
          break;
        case 'Fuerza':
          currentName = 'Fuerza';
          break;
        case 'Tabla':
          currentName = 'Tabla';
          break;
        case 'Cancha':
          currentName = 'Cancha Goles y Orígenes';
          break;
        case 'TendenciaLive':
          currentName = 'Tendencia';
          break;
        case 'GolstatsLive':
          currentName = 'Golstats LIVE';
          break;
      }
      return currentName;
    },
  },
  methods: {
    ...mapMutations('nextGeneral', ['updateIsSocketConnected']),
    setSize() {
      this.size = typeof this.$refs.matchAnalysis === 'undefined' ? this.size : this.$refs.matchAnalysis.clientWidth;
    },
    onCloseFilter() {
      analisisPartidosCerrarFiltroAvanzando(this.seasonId, this.gameId);
    },
    onApplyFilter(values) {
      analisisPartidosAplicarFiltros(this.seasonId, this.gameId, values);
    },
    onChangeLive() {
      analisisPartidoLive(this.seasonId, this.gameId);
    },
    onClickAdvancedFilter() {
      analisisPartidoFiltrosAvanzados(this.seasonId, this.gameId);
    },
    onChangeAnalytsis(value) {
      analisisPartidoFiltroTipoDeAnalisis(this.seasonId, this.gameId, value);
    },
    onChangeDistribucionLiveVista(value){
      analisisPartidoDistribucionLiveVista(this.seasonId, this.gameId, value);
    },
    onChangeTeamTendenciaLive(teamId) {
      analisisPartidoTendenciaLiveEquipo(this.seasonId, this.gameId, teamId);
    },
    onChangeTendenciaLiveVista(value) {
      analisisPartidoTendenciaLiveVista(this.seasonId, this.gameId, value);
    },
    onChangeTendenciaLiveSubcategory(value){
      analisisPartidoTendenciaLiveCategoria(this.seasonId, this.gameId, value);  
    }
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin: 20px 0 0 0;
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: no-display !important;

  .is-bordered-box-shadow-main {
    position: relative;
    padding-bottom: 30px;
    margin: 20px 0 0 0;
  }
}
@media screen and (max-width: 768px) {
  .main-container {
    padding: 0 5px 0 5px !important;
  }
}
.next-games-container {
  margin: 0 10px;
  padding: 10px 5px 0 5px;
  min-height: 400px;
  width: 100%;
  @media (min-width: 1100px) {
    width: 900px !important;
  }
  @media (min-width: 900px) {
    width: 800px !important;
  }
}
.container-view.mobile {
  margin: 0px 0.7rem;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2rem;
}
.flex-item {
  cursor: pointer;
  font-family: 'Avenir-Demi';
  font-size: 0.75rem;
  width: 50%;
  padding-top: 6%;
  padding-bottom: 6%;

  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;

  border-radius: 4px;
  /* border: 1px solid silver;*/
}
.menu-left {
  margin-left: 0.1rem;
  padding: 0 5px 0 5px;
}
.view-container-title {
  font-family: 'Circular-Std';
  background-color: #001d57;
  color: white;
  align-items: center;
  justify-content: center;
}
.match-live-notification {
  font-family: 'Circular-Std';
  font-size: 0.875em;
  padding: 6px 16px;
  width: 65px;
  height: 30px;
  opacity: 0.8;
  border-radius: 6px;
  border: solid 1px #ffffff;
  color: #ffffff;
}
.custom-section-container {
  padding: 0 2rem;
}
/* Olds Styles*/
.card {
  margin: 3rem;
  padding: 3rem;
}
.head {
  background-color: #001445;
  color: aliceblue;
  border-top: 1px solid;
  border-color: black;
}
.main-s {
  background-color: #77ba3f;
  color: aliceblue;
  border-top: 1px solid;
  border-color: black;
}
.main-s h4 {
  color: white;
}
.main {
  border-top: 1px solid;
  border-color: black;
}
.head h1 {
  color: white;
}
.container {
  margin: 3rem;
}
.row {
  background-color: transparent;
  border-color: transparent;
  padding: 2px;
  width: 90%;
}
.panel {
  padding-bottom: 2rem;
}
.advance {
  font-size: 3rem;
}
.icon-down {
  color: crimson;
}
.icon-up {
  color: green;
}
.advanced {
  background-color: #7ed321;
  color: white;
}
.item.a {
  margin-bottom: 0px;
}
.disabled {
  pointer-events: none;
  /* for "disabled" effect */
  opacity: 0.5;
}
@media screen and (max-width: 768px) {
  .container-view {
    margin: 0 0rem;
    background-color: white;
  }
  .container-view.mobile {
    margin: 0px 0rem;
  }
  .main-container {
    margin: 0px;
    display: flex;
    justify-content: center;
    .is-bordered-box-shadow-main {
      margin: 0;
      padding-bottom: 0;
    }
    .next-matches-title {
      font-family: 'Avenir-Demi';
      font-size: 1.2rem;
      margin: 0 0 10px 0;
      color: #6f7072;
    }
  }
  .next-games-container {
    margin: 0;
    padding: 15px 0 15px 0;
  }
  .child-container {
    padding: 15px;
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (max-width: 500px) {
  .child-container {
    margin: 5px !important;
    padding: 2px !important;
  }
}

@media screen and (max-width: 400px) {
  .child-container {
    margin: 5px !important;
    padding: 1px !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 300px) {
  .general {
    width: 98vw;
  }
}
</style>
